import React, { forwardRef, useEffect, useImperativeHandle, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, Checkbox, DatePicker, Form, Input, InputNumber, Select, Tag, message, Upload, Space, Table, Spin } from 'antd'
import { MinusCircleOutlined, InboxOutlined, CloseOutlined } from '@ant-design/icons'
import Icon from '@ant-design/icons'
import { Col, Grid, Row } from 'react-flexbox-grid'
import * as Constants from '../../../constants'
import { storage, firestore } from '../../../config/Fire'
import './style.css'

const { Dragger } = Upload;
const { Option } = Select
const { TextArea } = Input

const FormWorkOrder = forwardRef((props, ref) => {
    const { employees, clients, loading, onSubmitWorkOrder, isEditing, workOrderToEdit, bidData } = props
    const [form] = Form.useForm()
    const [employeesFiltered, setEmployeesFiltered] = useState([])
    const [clientsFiltered, setClientsFiltered] = useState([])
    const [workOrderIsSAT, setWorkOrderIsSAT] = useState(false)
    const [areasSelected, setAreasSelected] = useState([])
    const [categorySelected, setCategorySelected] = useState([])
    const [companySelected, setCompanySelected] = useState([])
    const [fileUrl, setFileUrl] = useState(null)
    const [fileName, setFileName] = useState(null)
    const [fileNameValidation, setFileNameValidation] = useState(null)
    const [fileUrlValidation, setFileUrlValidation] = useState(null)
    const [isDelivered, setIsDelivered] = useState(false)
    const [loadingFile, setLoadingFile] = useState(false)
    const draggerProps = {
        name: 'file',
        action: (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            })
        },
        headers: {
            Authorization: 'Access-Control-Allow-Origin'
        },
        accept: '.pdf',
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
                setFileUrl(info.file)
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };
    const draggerPropsValidation = {
        name: 'file',
        action: (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            })
        },
        headers: {
            Authorization: 'Access-Control-Allow-Origin'
        },
        accept: '.pdf',
        onChange(info) {
            const { status } = info.file;
            if (status === 'done') {
                message.success(`${info.file.name} file uploaded successfully.`);
                setFileUrlValidation(info.file)
            } else if (status === 'error') {
                message.error(`${info.file.name} file upload failed.`);
            }
        },
        onDrop(e) {
            console.log('Dropped files', e.dataTransfer.files);
        },
    };
    const linkFileRef = useRef(null)
    const linkValidationFileRef = useRef(null)

    const GoogleCalendarSvg = () => (
        <svg width="32" height="32" version="1.1" viewBox="0 0 76 76" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(-186,-38)">
                <path d="M244 56h-40v40h40V56z" fill="#fff" />
                <path
                    d="M212.205 87.03c-1.495-1.01-2.53-2.485-3.095-4.435l3.47-1.43c.315 1.2.865 2.13 1.65 2.79.78.66 1.73.985 2.84.985 1.135 0 2.11-.345 2.925-1.035s1.225-1.57 1.225-2.635c0-1.09-.43-1.98-1.29-2.67-.86-.69-1.94-1.035-3.23-1.035h-2.005V74.13h1.8c1.11 0 2.045-.3 2.805-.9.76-.6 1.14-1.42 1.14-2.465 0 -.93-.34-1.67-1.02-2.225-.68-.555-1.54-.835-2.585-.835-1.02 0 -1.83.27-2.43.815a4.784 4.784 0 0 0 -1.31 2.005l-3.435-1.43c.455-1.29 1.29-2.43 2.515-3.415 1.225-.985 2.79-1.48 4.69-1.48 1.405 0 2.67.27 3.79.815 1.12.545 2 1.3 2.635 2.26.635.965.95 2.045.95 3.245 0 1.225-.295 2.26-.885 3.11-.59.85-1.315 1.5-2.175 1.955v.205a6.605 6.605 0 0 1 2.79 2.175c.725.975 1.09 2.14 1.09 3.5 0 1.36-.345 2.575-1.035 3.64s-1.645 1.905-2.855 2.515c-1.215.61-2.58.92-4.095.92-1.755.005-3.375-.5-4.87-1.51zM233.52 69.81l-3.81 2.755-1.905-2.89 6.835-4.93h2.62V88h-3.74V69.81z"
                    fill="#4285F4" />
                <path d="M244 96h-40v18h40V96z" fill="#34A853" />
                <path d="M244 38h-52c-3.315 0 -6 2.685-6 6v52h18V56h40V38z" fill="#4285F4" />
                <path d="M186 96v12c0 3.315 2.685 6 6 6h12V96h-18z" fill="#188038" />
                <path d="M262 56h-18v40h18V56z" fill="#FBBC04" />
                <path d="M262 56V44c0-3.315-2.685-6-6-6h-12v18h18z" fill="#1967D2" />
                <path d="M244 114l18-18h-18v18z" fill="#EA4335" />
            </g>
        </svg>)
    const GoogleCalendarIcon = props => <Icon component={GoogleCalendarSvg} {...props} />

    useEffect(() => {
        if (employees) {
            const usersToFilter = Object.values(employees)
            setEmployeesFiltered(usersToFilter)
        }
        setIsDelivered(workOrderToEdit.delivered)
        
        // Validación y recuperación del archivo OT
        if (isEditing && workOrderToEdit) {
            setLoadingFile(true)
            const defaultPath = `works/${workOrderToEdit.id}/OT.pdf`;
            const currentPath = workOrderToEdit.fileUrl || defaultPath;
            
            const checkFileExists = (path, retries = 15, delay = 2000) => {
                storage.ref().child(path).getMetadata()
                    .then(() => {
                        // El archivo existe
                        setFileName(workOrderToEdit.fileName || 'OT.pdf');
                        workOrderToEdit.fileUrl = path; // Aseguro que el objeto a editar tenga el path real
                        setLoadingFile(false);
                    })
                    .catch(err => {
                        // storage/object-not-found means it's not there yet
                        if (err.code === 'storage/object-not-found' && retries > 0) {
                            setTimeout(() => checkFileExists(path, retries - 1, delay), delay);
                        } else if (path !== defaultPath && retries === 0) {
                            // Si tras los reintentos no lo encuentra en la ruta guardada, intentar en la por defecto
                            checkFileExists(defaultPath, 3, delay);
                        } else {
                            setFileName(null);
                            setLoadingFile(false);
                        }
                    });
            };

            checkFileExists(currentPath);
        } else if (workOrderToEdit.fileName) {
            setFileName(workOrderToEdit.fileName)
        } else {
            setFileName('OT.pdf')
        }
        setFileNameValidation(workOrderToEdit.validationName)
    }, [employees])

    useEffect(() => {
        if (clients) {
            const usersToFilter = Object.values(clients)
            setClientsFiltered(usersToFilter)
        }
    }, [clients])

    useEffect(() => {
        if (isEditing) {
            setWorkOrderIsSAT(workOrderToEdit.SAT !== undefined ? workOrderToEdit.SAT : false)
        }
        if (workOrderToEdit && workOrderToEdit.areas) {
            let updatedAreas = [...workOrderToEdit.areas];
            if (workOrderToEdit.outsourced) {
                updatedAreas.push('Tercerizado');
            }
            setAreasSelected(updatedAreas);
        }
    }, [])

    const filterEmployees = value => {
        setEmployeesFiltered([])
        if (employees) {
            const valueLowerCase = value.toLowerCase()
            const employeesFinded = Object.values(employees).filter(employee => employee.email.toLowerCase().includes(valueLowerCase) ||
                (employee.name !== undefined && employee.name.toLowerCase().includes(valueLowerCase)))
            setEmployeesFiltered(employeesFinded)
        }
    }

    const filterClients = value => {
        setClientsFiltered([])
        if (clients) {
            const valueLowerCase = value.toLowerCase()
            const clientsFinded = Object.values(clients).filter(client => client.email.toLowerCase().includes(valueLowerCase) ||
                (client.name !== undefined && client.name.toLowerCase().includes(valueLowerCase)))
            setClientsFiltered(clientsFinded)
        }
    }

    const clearWorkOrder = () => {
        form.resetFields()
        setAreasSelected([])
        if (workOrderToEdit && workOrderToEdit.areas) {
            let updatedAreas = [...workOrderToEdit.areas];
            if (workOrderToEdit.outsourced) {
                updatedAreas.push('Tercerizado');
            }
            setAreasSelected(updatedAreas);
            setWorkOrderIsSAT(workOrderToEdit.SAT)
        } else {
            setWorkOrderIsSAT(false)
        }
    }

    useImperativeHandle(ref, () => ({
        resetCompletionPercentage() {
            form.resetFields(['completionPercentage'])
        }
    }))

    const getOTLabel = (workOrder) => {
        const company = workOrder?.company === 'SD' ? 'SYD' : workOrder?.company === 'Arcasa' ? 'ARC' : 'O/T'
        const yearStr = workOrder.year ? (moment.isMoment(workOrder.year) || typeof workOrder.year === 'object' ? moment(workOrder.year).format('YY') : workOrder.year.toString().substring(2, 4)) : ''
        if (workOrder.SAT) {
            return `${company} Nº${workOrder.workOrderNumber}/${yearStr} (SAT)`
        } else {
            return `${company} Nº${workOrder.workOrderNumber}/${yearStr}`
        }
    }

    // Función para convertir archivo de Storage a base64
    const getFileAsBase64FromStorage = async (fileUrl) => {
        try {
            const url = await storage.ref().child(fileUrl).getDownloadURL()
            const response = await fetch(url)
            const blob = await response.blob()
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => {
                    const base64String = reader.result.split(',')[1] // Remover el prefijo data:application/pdf;base64,
                    resolve(base64String)
                }
                reader.onerror = reject
                reader.readAsDataURL(blob)
            })
        } catch (error) {
            console.log('Error al convertir archivo a base64 desde Storage:', error)
            return null
        }
    }

    // Función para convertir File a base64
    const getFileAsBase64FromFile = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => {
                const base64String = reader.result.split(',')[1] // Remover el prefijo data:application/pdf;base64,
                resolve(base64String)
            }
            reader.onerror = reject
            reader.readAsDataURL(file)
        })
    }

    // Función para enviar POST a Power Automate (sin bloquear el flujo)
    const sendToPowerAutomate = (workOrderData, fileObject = null) => {
        try {
            // Obtener emails de profesionales (requerido por Power Automate)
            let professionalEmails = ''
            if (workOrderData.professionalIds && workOrderData.professionalIds.length > 0 && employees) {
                const emails = workOrderData.professionalIds
                    .map(id => employees[id]?.email)
                    .filter(email => email)
                professionalEmails = emails.join(', ')
            }

            // Obtener nombres de comitentes
            let clientNames = ''
            if (workOrderData.clientIds && workOrderData.clientIds.length > 0 && clients) {
                const names = workOrderData.clientIds
                    .map(id => clients[id]?.name)
                    .filter(name => name)
                clientNames = names.join(', ')
            }

            // Obtener items mapeados
            const items = workOrderData.selectedItems || workOrderData.items || []
            const mappedItems = items.map(item => ({
                nombre: item.name || '',
                descripcion: item.description || '',
                plazoDias: (item.days !== null && item.days !== undefined && !isNaN(parseInt(item.days))) ? parseInt(item.days) : 0
            }))

            // Función para enviar el payload con retry
            const sendPayload = (fileBase64, retryCount = 0) => {
                if (!fileBase64) {
                    console.log('No se pudo obtener el archivo para Power Automate')
                    return
                }

                // Obtener la key de la categoría
                let categoryKey = workOrderData.category || ''
                if (workOrderData.category) {
                    // Buscar la key en los mapas de categorías
                    const sdKey = Object.keys(Constants.categorySDBidOrderMap).find(key => Constants.categorySDBidOrderMap[key] === workOrderData.category)
                    const arcasaKey = Object.keys(Constants.categoryARCASABidOrderMap).find(key => Constants.categoryARCASABidOrderMap[key] === workOrderData.category)

                    if (sdKey) categoryKey = sdKey
                    else if (arcasaKey) categoryKey = arcasaKey
                }

                const payload = {
                    ot: (() => {
                        const company = workOrderData?.company === 'SD' ? 'SYD' : workOrderData?.company === 'Arcasa' ? 'ARC' : 'O/T'
                        const yearStr = workOrderData.year ? (moment.isMoment(workOrderData.year) || typeof workOrderData.year === 'object' ? moment(workOrderData.year).format('YY') : workOrderData.year.toString().substring(2, 4)) : ''
                        return `${company}-${yearStr}-${workOrderData.workOrderNumber}${workOrderData.SAT ? ' (SAT)' : ''}`
                    })() || '',
                    descripcionOt: workOrderData.task || workOrderData.quotationObservations || '',
                    rubro: categoryKey || '',
                    profesional: professionalEmails || '',
                    localidad: workOrderData.locality || '',
                    pais: bidData?.country || '',
                    provincia: bidData?.province || '',
                    comitente: clientNames || '',
                    archivoOt: {
                        fileName: workOrderData.fileName || 'OT.pdf',
                        contentType: 'application/pdf',
                        fileBase64: fileBase64 || ''
                    },
                    items: mappedItems
                }

                let endpointUrl = ''
                if (workOrderData.company === 'SD') {
                    endpointUrl = 'https://defaultf5575bce335945d8b6a77a0e194fce.8a.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/c662f88ee62745999f1654c8be99aafa/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=LIar3z2ALaY4EmSTZSVIj2dUmNXYSNWZT4wubldlH2A'
                } else if (workOrderData.company === 'Arcasa') {
                    console.log('Endpoint de Power Automate para Arcasa aún no configurado.')
                    return
                } else {
                    console.log('Empresa desconocida, se omite envío a Power Automate.')
                    return
                }

                fetch(endpointUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                })
                    .then(async response => {
                        if (!response.ok) {
                            const errorText = await response.text()
                            console.log('Error en respuesta de Power Automate:', response.status, response.statusText, errorText)
                            // Reintentar si es la primera vez
                            if (retryCount === 0) {
                                console.log('Reintentando envío a Power Automate...')
                                setTimeout(() => {
                                    sendPayload(fileBase64, 1)
                                }, 2000) // Esperar 2 segundos antes de reintentar
                            } else {
                                console.log('Error persistente en Power Automate después del reintento')
                            }
                        }
                    })
                    .catch(error => {
                        console.log('Error al enviar a Power Automate:', error)
                        // Reintentar si es la primera vez
                        if (retryCount === 0) {
                            console.log('Reintentando envío a Power Automate después de error...')
                            setTimeout(() => {
                                sendPayload(fileBase64, 1)
                            }, 2000) // Esperar 2 segundos antes de reintentar
                        } else {
                            console.log('Error persistente en Power Automate después del reintento')
                        }
                    })
            }

            // Si hay un archivo File (nueva OT), convertirlo directamente
            if (fileObject && fileObject.file && fileObject.file.originFileObj) {
                getFileAsBase64FromFile(fileObject.file.originFileObj)
                    .then(fileBase64 => sendPayload(fileBase64))
                    .catch(error => {
                        console.log('Error al convertir archivo File a base64:', error)
                    })
            }
            // Si hay fileUrl (OT editada o ya creada), leerlo desde Storage
            else if (workOrderData.fileUrl) {
                getFileAsBase64FromStorage(workOrderData.fileUrl)
                    .then(fileBase64 => sendPayload(fileBase64))
                    .catch(error => {
                        console.log('Error al obtener archivo desde Storage:', error)
                    })
            } else {
                console.log('No hay archivo OT para enviar a Power Automate', workOrderData)
            }
        } catch (error) {
            console.log('Error en sendToPowerAutomate:', error)
        }
    }

    const handleSubmit = async values => {
        const items = workOrderToEdit && (workOrderToEdit.selectedItems || workOrderToEdit.items) ? (workOrderToEdit.selectedItems || workOrderToEdit.items) : []
        const hasItems = items.length > 0

        // Actualizar items con porcentajes libre y facturado, y estado terminado
        let updatedItems = []
        if (hasItems) {
            updatedItems = items.map(item => ({
                ...item,
                invoicedFreePercentaje: values[`invoicedFreePercentajeItem${item.id}`] !== undefined
                    ? parseFloat(values[`invoicedFreePercentajeItem${item.id}`]) || 0
                    : (item.invoicedFreePercentaje || 0),
                invoicedPercentaje: values[`invoicedPercentajeItem${item.id}`] !== undefined
                    ? parseFloat(values[`invoicedPercentajeItem${item.id}`]) || 0
                    : (item.invoicedPercentaje || 0),
                completed: values[`completedItem${item.id}`] !== undefined
                    ? values[`completedItem${item.id}`]
                    : (item.completed || false)
            }))
        }

        if (isEditing && workOrderToEdit) {
            if (values.fileItem?.file !== undefined) {
                let fileUrl = `works/${workOrderToEdit.id}/OT.pdf`;
                try {
                    await storage.ref().child(fileUrl).put(values.fileItem.file.originFileObj)
                    workOrderToEdit.fileUrl = fileUrl
                    setFileName(values.fileItem.file.name)
                } catch (err) {
                    console.log(err)
                    message.error('Se produjo un error al editar la orden de trabajo. Por favor, vuelva a intentarlo')
                    return
                }
            }
            if (values.fileItemValidation?.file !== undefined) {
                let validationFileUrl = `works/${workOrderToEdit.id}/validacion.pdf`;
                try {
                    await storage.ref().child(validationFileUrl).put(values.fileItemValidation.file.originFileObj)
                    workOrderToEdit.validationFileUrl = validationFileUrl
                    if (values.fileItemValidation.file.name !== undefined) setFileNameValidation(values.fileItemValidation.file.name)
                } catch (err) {
                    console.log(err)
                    message.error('Se produjo un error al editar la orden de trabajo. Por favor, vuelva a intentarlo')
                    return
                }
            }
            // Construir objeto workOrder eliminando campos undefined
            const workOrder = {
                ...workOrderToEdit,
                company: values.company !== undefined ? values.company : '',
                category: values.category !== undefined ? values.category : '',
                areas: values.areas !== undefined ? values.areas : [],
                selectedItems: hasItems ? updatedItems : (workOrderToEdit.selectedItems || workOrderToEdit.items || []),
                items: hasItems ? updatedItems : (workOrderToEdit.selectedItems || workOrderToEdit.items || []),
                professionalIds: values.professionals !== undefined ? values.professionals : [],
                task: values.task !== undefined ? values.task : '',
                SAT: workOrderIsSAT,
                workOrderNumber: values.workOrderNumber !== undefined ? values.workOrderNumber : 0,
                year: values.year !== undefined ? parseInt(moment(values.year).format('YYYY')) : 0,
                clientIds: values.clients !== undefined ? values.clients : [],
                locality: values.locality !== undefined ? values.locality : '',
                startDate: values.startDate ? moment(values.startDate).format('DD/MM/YYYY') : '',
                expectedCompletionDate: values.expectedCompletionDate ? moment(values.expectedCompletionDate).format('DD/MM/YYYY') : '',
                effectiveEndDate: values.effectiveEndDate ? moment(values.effectiveEndDate).format('DD/MM/YYYY') : '',
                delivered: values.delivered !== undefined ? values.delivered : false,
                engineeringDays: values.delivered ? (values.engineeringDays !== undefined ? parseInt(values.engineeringDays) : 0) : 0,
                // payAtDay: values.payAtDay !== undefined ? values.payAtDay : false,
                outsourced: values.outsourced !== undefined ? values.outsourced : false,
                observations: values.observations !== undefined ? values.observations : '',
                trackingLink: values.trackingLink !== undefined ? values.trackingLink : '',
                fileName: values.fileItem?.file !== undefined ? values.fileItem.file.name : (values.fileItem || workOrderToEdit.fileName || 'OT.pdf'),
                file: values.fileItem?.file !== undefined ? values.fileItem.file.originFileObj : null,
                fileUrl: workOrderToEdit.fileUrl || `works/${workOrderToEdit.id}/OT.pdf`, // Garantizo que tenga una url válida para Power Automate
                validationName: values.fileItemValidation?.file !== undefined ? values.fileItemValidation.file?.name : (workOrderToEdit.validationName || null),
                validationFile: values.fileItemValidation?.file !== undefined ? values.fileItemValidation.file?.originFileObj : null,
                // hasTopography: values.hasTopography !== undefined && values.hasTopography === true ? 'Pendiente de viaje' : values.hasTopography !== undefined && values.hasTopography === false ? 'No contempla' : (workOrderToEdit.hasTopography || null),
                quotationObservations: values.quotationObservations !== undefined ? values.quotationObservations : (workOrderToEdit.quotationObservations || ''),
            }

            // Función recursiva para eliminar campos undefined
            const removeUndefinedFields = (obj) => {
                if (obj === null || obj === undefined) {
                    return null
                }
                if (Array.isArray(obj)) {
                    return obj.map(item => removeUndefinedFields(item)).filter(item => item !== undefined)
                }
                if (typeof obj === 'object') {
                    const cleaned = {}
                    Object.keys(obj).forEach(key => {
                        if (obj[key] !== undefined) {
                            const cleanedValue = removeUndefinedFields(obj[key])
                            if (cleanedValue !== undefined) {
                                cleaned[key] = cleanedValue
                            }
                        }
                    })
                    return cleaned
                }
                return obj
            }
            // Eliminar campos undefined del objeto recursivamente
            const cleanedWorkOrder = removeUndefinedFields(workOrder)

            // Validar si es la primera vez que se completa/edita para mandarlo a Power Automate
            // Solo se marca como enviado si es SD, para que Arcasa pueda enviarse cuando tenga endpoint
            if (!workOrderToEdit.powerAutomateSent && cleanedWorkOrder.company === 'SD') {
                sendToPowerAutomate(cleanedWorkOrder, values.fileItem)
                cleanedWorkOrder.powerAutomateSent = true
                workOrderToEdit.powerAutomateSent = true
            }

            onSubmitWorkOrder(cleanedWorkOrder)
        } else {
            const workOrder = {
                company: values.company !== undefined ? values.company : '',
                category: values.category !== undefined ? values.category : '',
                areas: values.areas !== undefined ? values.areas : [],
                selectedItems: hasItems ? updatedItems : [],
                items: hasItems ? updatedItems : [],
                professionalIds: values.professionals !== undefined ? values.professionals : [],
                task: values.task !== undefined ? values.task : '',
                SAT: workOrderIsSAT,
                workOrderNumber: values.workOrderNumber !== undefined ? values.workOrderNumber : 0,
                year: values.year !== undefined ? parseInt(moment(values.year).format('YYYY')) : 0,
                clientIds: values.clients !== undefined ? values.clients : [],
                locality: values.locality !== undefined ? values.locality : '',
                startDate: values.startDate ? moment(values.startDate).format('DD/MM/YYYY') : '',
                expectedCompletionDate: values.expectedCompletionDate ? moment(values.expectedCompletionDate).format('DD/MM/YYYY') : '',
                effectiveEndDate: values.effectiveEndDate ? moment(values.effectiveEndDate).format('DD/MM/YYYY') : '',
                delivered: values.delivered !== undefined ? values.delivered : false,
                engineeringDays: values.delivered ? (values.engineeringDays !== undefined ? parseInt(values.engineeringDays) : 0) : 0,
                // payAtDay: values.payAtDay !== undefined ? values.payAtDay : false,
                outsourced: values.outsourced !== undefined ? values.outsourced : false,
                //completionPercentage: values.completionPercentage !== undefined ? values.completionPercentage : 0,
                // onTime: values.onTime !== undefined ? values.onTime : false,
                observations: values.observations !== undefined ? values.observations : '',
                quotationObservations: values.quotationObservations !== undefined ? values.quotationObservations : (workOrderToEdit?.quotationObservations || ''),
                trackingLink: values.trackingLink !== undefined ? values.trackingLink : '',
                fileName: values.fileItem ? values.fileItem.file.name : '',
                file: values.fileItem ? values.fileItem.file.originFileObj : null,
                validationName: values.fileItemValidation ? values.fileItemValidation.file.name : '',
                validationFile: values.fileItemValidation ? values.fileItemValidation.file.originFileObj : null,
                // hasTopography:  values.hasTopography !== undefined && values.hasTopography === true ? 'Pendiente de viaje' : values.hasTopography !== undefined && values.hasTopography === false ? 'No contempla' : values.hasTopography,
            }
            onSubmitWorkOrder(workOrder)
        }
    }

    const getInitialValuesFromWorkOrder = () => {
        // Cargar valores de porcentajes y estado terminado desde items
        const itemsPercentagesFields = {}
        const items = workOrderToEdit.selectedItems || workOrderToEdit.items || []
        if (items && items.length > 0) {
            items.forEach(item => {
                if (item.invoicedFreePercentaje !== undefined) {
                    itemsPercentagesFields[`invoicedFreePercentajeItem${item.id}`] = item.invoicedFreePercentaje
                }
                if (item.invoicedPercentaje !== undefined) {
                    itemsPercentagesFields[`invoicedPercentajeItem${item.id}`] = item.invoicedPercentaje
                }
                if (item.completed !== undefined) {
                    itemsPercentagesFields[`completedItem${item.id}`] = item.completed
                }
            })
        }

        return {
            ...itemsPercentagesFields,
            company: workOrderToEdit.company ? workOrderToEdit.company : undefined,
            category: workOrderToEdit.category ? workOrderToEdit.category : undefined,
            areas: workOrderToEdit.areas ? workOrderToEdit.areas : undefined,
            professionals: workOrderToEdit.professionalIds && workOrderToEdit.professionalIds.length > 0 && workOrderToEdit.professionalIds[0] ? workOrderToEdit.professionalIds : undefined,
            task: workOrderToEdit.task ? workOrderToEdit.task : undefined,
            SAT: workOrderToEdit.SAT,
            workOrderNumber: workOrderToEdit.workOrderNumber ? workOrderToEdit.workOrderNumber : undefined,
            year: workOrderToEdit.year ? moment(workOrderToEdit.year, 'YYYY') : undefined,
            clients: workOrderToEdit.clientIds && workOrderToEdit.clientIds.length > 0 && workOrderToEdit.clientIds[0] ? workOrderToEdit.clientIds : undefined,
            locality: workOrderToEdit.locality ? workOrderToEdit.locality : undefined,
            startDate: workOrderToEdit.startDate ? moment(workOrderToEdit.startDate, 'DD/MM/YYYY') : undefined,
            expectedCompletionDate: workOrderToEdit.expectedCompletionDate ? moment(workOrderToEdit.expectedCompletionDate, 'DD/MM/YYYY') : undefined,
            effectiveEndDate: workOrderToEdit.effectiveEndDate ? moment(workOrderToEdit.effectiveEndDate, 'DD/MM/YYYY') : undefined,
            // deliveryDate: workOrderToEdit.deliveryDate ? moment(workOrderToEdit.deliveryDate, 'DD/MM/YYYY') : undefined,
            delivered: workOrderToEdit.delivered !== undefined ? workOrderToEdit.delivered : undefined,
            engineeringDays: workOrderToEdit.engineeringDays !== undefined ? workOrderToEdit.engineeringDays : undefined,
            // payAtDay: workOrderToEdit.payAtDay !== undefined ? workOrderToEdit.payAtDay : undefined,
            outsourced: workOrderToEdit.outsourced ? workOrderToEdit.outsourced : undefined,
            //completionPercentage: workOrderToEdit.completionPercentage ? workOrderToEdit.completionPercentage : undefined,
            // onTime: workOrderToEdit.onTime ? workOrderToEdit.onTime : undefined,
            observations: workOrderToEdit.observations !== undefined ? workOrderToEdit.observations : undefined,
            quotationObservations: workOrderToEdit.quotationObservations !== undefined ? workOrderToEdit.quotationObservations : undefined,
            trackingLink: workOrderToEdit.trackingLink !== undefined ? workOrderToEdit.trackingLink : undefined,
            fileItem: workOrderToEdit.fileName ? workOrderToEdit.fileName : undefined,
            fileItemValidation: workOrderToEdit.validationName !== null ? workOrderToEdit.validationName : undefined,
            // hasTopography: workOrderToEdit.hasTopography === true ? 'Pendiente de viaje' : workOrderToEdit.hasTopography === false ? 'No contempla' : workOrderToEdit.hasTopography,
        }
    }

    const onAddExpectedCompletionDateToGoogleCalendar = () => {
        const values = form.getFieldsValue()
        const expectedCompletionDate = values['expectedCompletionDate']
        const task = values['task']
        const workOrderNumber = values['workOrderNumber']
        const year = values['year']
        const locality = values['locality']
        if (workOrderIsSAT) {
            form.validateFields(['task', 'year', 'locality'])
        } else {
            form.validateFields(['task', 'workOrderNumber', 'year', 'locality'])
        }
        if (task && (workOrderIsSAT || workOrderNumber) && year && locality) {
            if (expectedCompletionDate) {
                const gapi = window.gapi
                gapi.load('client:auth2', () => {
                    gapi.client.init({
                        apiKey: Constants.GOOGLE_API.API_KEY,
                        clientId: Constants.GOOGLE_API.CLIENT_ID,
                        discoveryDocs: Constants.GOOGLE_API.DISCOVERY_DOCS,
                        scope: Constants.GOOGLE_API.SCOPES
                    })
                    gapi.client.load('calendar', 'v3', () => console.log('bam!'))
                    gapi.auth2.getAuthInstance().signIn()
                        .then(() => {
                            const event = {
                                'summary': `${task} (${locality}) - Orden de Trabajo - Grupo SADE`,
                                'description': `${workOrderIsSAT ? `O/T SAT/${year.toString().substring(2, 4)}` : `O/T Nº${workOrderNumber}/${moment(values.year).format('YYYY').toString().substring(2, 4)}`}`,
                                'start': {
                                    'dateTime': moment(`${expectedCompletionDate.format('DD/MM/YYYY')} 00:00 -0300`, 'DD/MM/YYYY HH:mm Z').format('YYYY-MM-DDTHH:mm:ssZ'),
                                    'timeZone': 'America/Argentina/Buenos_Aires'
                                },
                                'end': {
                                    'dateTime': moment(`${expectedCompletionDate.format('DD/MM/YYYY')} 23:59 -0300`, 'DD/MM/YYYY HH:mm Z').format('YYYY-MM-DDTHH:mm:ssZ'),
                                    'timeZone': 'America/Argentina/Buenos_Aires'
                                },
                                'reminders': {
                                    'useDefault': false,
                                    'overrides': [
                                        { 'method': 'email', 'minutes': 24 * 60 },
                                        { 'method': 'popup', 'minutes': 2 * 60 }
                                    ]
                                }
                            }
                            const request = gapi.client.calendar.events.insert({
                                'calendarId': 'primary',
                                'resource': event
                            });

                            request.execute(function (event) {
                                window.open(event.htmlLink)
                            });
                        })
                })
            } else {
                message.warn('Debe tener una fecha de finalización prevista para agregar al calendario')
            }
        } else {
            message.warn('Complete los campos para cargar la OT al calendario')
        }
    }

    const asignCompanyAndChangeCategory = (company) => {
        setCompanySelected(company)
        form.setFieldsValue({ category: undefined })
        setCategorySelected([])
    }

    const downloadFile = (type) => {
        if (type === 'order') {
            const defaultPath = `works/${workOrderToEdit.id}/OT.pdf`;
            const currentPath = workOrderToEdit.fileUrl || defaultPath;
            
            storage.ref().child(currentPath).getDownloadURL()
                .then(url => {
                    if (linkFileRef && linkFileRef.current) {
                        linkFileRef.current.href = url
                        linkFileRef.current.click();
                    }
                })
                .catch(err => {
                    console.log('Error al descargar desde la ruta actual, intentando ruta por defecto:', err);
                    // Reintento con la ruta estándar si la actual falló
                    if (currentPath !== defaultPath) {
                        storage.ref().child(defaultPath).getDownloadURL()
                            .then(url => {
                                if (linkFileRef && linkFileRef.current) {
                                    linkFileRef.current.href = url
                                    linkFileRef.current.click();
                                }
                            })
                            .catch(() => message.error('No se pudo encontrar el archivo OT en el servidor.'));
                    } else {
                        message.error('El archivo OT no existe en el almacenamiento.');
                    }
                });
        } else {
            storage.ref().child(workOrderToEdit.validationFileUrl).getDownloadURL().then(url => {
                if (linkValidationFileRef && linkValidationFileRef.current) {
                    linkValidationFileRef.current.href = url
                    linkValidationFileRef.current.click();
                }
            }).catch(() => message.error('No se pudo encontrar el archivo de validación.'));
        }
    }

    const deleteFile = (type) => {
        if (type === 'order') {
            storage.ref().child(workOrderToEdit.fileUrl).delete().then(() => {
                setFileName(null)
            }).catch(err => {
                console.log(err)
                message.error('Se produjo un error al eliminar el archivo. Por favor, vuelva a intentarlo')
            })
            // delete from firestore
            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(workOrderToEdit.id).update({ fileUrl: null, fileName: null })
                .then(() => {
                    message.success('Se eliminó el archivo correctamente')
                })
                .catch(err => {
                    console.log(err)
                    message.error('Se produjo un error al eliminar el archivo. Por favor, vuelva a intentarlo')
                })
        } else {
            storage.ref().child(workOrderToEdit.validationFileUrl).delete().then(() => {
                setFileNameValidation(null)
            }).catch(err => {
                console.log(err)
                message.error('Se produjo un error al eliminar el archivo. Por favor, vuelva a intentarlo')
            })
            // delete from firestore
            firestore.collection(Constants.MAIN_NODES.WORK_ORDERS).doc(workOrderToEdit.id).update({ validationFileUrl: null, validationName: null })
                .then(() => {
                    message.success('Se eliminó el archivo correctamente')
                })
                .catch(err => {
                    console.log(err)
                    message.error('Se produjo un error al eliminar el archivo. Por favor, vuelva a intentarlo')
                })
        }
    }

    const handleCheckboxChange = (e) => {
        const { checked } = e.target;
        if (checked) {
            setAreasSelected(prevAreas => [...prevAreas, 'Tercerizado']);
        } else {
            setAreasSelected(prevAreas => prevAreas.filter(area => area !== 'Tercerizado'));
        }
    };

    const addNewArea = (props) => {
        let updatedAreas = [...props];
        if (areasSelected.includes('Tercerizado') && !updatedAreas.includes('Tercerizado')) {
            updatedAreas.push('Tercerizado');
        }
        setAreasSelected(updatedAreas);
    }


    return (
        <Spin spinning={loadingFile} tip="Localizando archivo de OT...">
        <Grid>
            <Form onFinish={handleSubmit} form={form} initialValues={isEditing && getInitialValuesFromWorkOrder()}>
                <Row>
                    <Col xs={12} md={3}>
                        <Form.Item name="company" rules={[{ required: true, message: 'Seleccione una empresa' }]}>
                            <Select placeholder="Empresa" onChange={company => asignCompanyAndChangeCategory(company)}>
                                {
                                    Constants.companyBidOrderMap && Object.keys(Constants.companyBidOrderMap).map(key =>
                                        <Option key={Constants.companyBidOrderMap[key]}
                                            value={Constants.companyBidOrderMap[key]}>{Constants.companyBidOrderMap[key]}
                                        </Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Item name="category" rules={[{ required: true, message: 'Seleccione un rubro' }]}>
                            <Select placeholder="Rubro" onChange={category => setCategorySelected(category)}>
                                {
                                    companySelected === 'Arcasa' ?
                                        Constants.categoryARCASABidOrderMap && Object.keys(Constants.categoryARCASABidOrderMap).map(key =>
                                            <Option key={Constants.categoryARCASABidOrderMap[key]}
                                                value={Constants.categoryARCASABidOrderMap[key]}>{Constants.categoryARCASABidOrderMap[key]}
                                            </Option>)
                                        : companySelected === 'SD' ?
                                            Constants.categorySDBidOrderMap && Object.keys(Constants.categorySDBidOrderMap).map(key =>
                                                <Option key={Constants.categorySDBidOrderMap[key]}
                                                    value={Constants.categorySDBidOrderMap[key]}>{Constants.categorySDBidOrderMap[key]}
                                                </Option>)
                                            : null
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Item name="areas" rules={[{ required: true, message: 'Seleccione el área' }]}>
                            <Select placeholder="Áreas" mode="multiple" onChange={areas => addNewArea(areas)}>
                                {
                                    Constants.areaWorkOrderMap && Object.keys(Constants.areaWorkOrderMap).map(key =>
                                        <Option key={Constants.areaWorkOrderMap[key]}
                                            value={Constants.areaWorkOrderMap[key]}>{Constants.areaWorkOrderMap[key]}
                                        </Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Item name="professionals"
                            rules={[{ required: true, message: 'Seleccione un profesional' }, {
                                validator: async (rule, value) => {
                                    if (value) {
                                        if (value.length > 1) {
                                            throw new Error('El máximo es de 1 profesional')
                                        }
                                    }
                                }
                            }]}>
                            <Select
                                mode="multiple"
                                maxTagCount={2}
                                placeholder="Profesional a cargo"
                                filterOption={false}
                                onSearch={filterEmployees}
                                style={{ width: '100%' }}>
                                {employeesFiltered.map(d => (
                                    d.enabled ?
                                        <Option
                                            key={d.id} value={d.id}>{`${d.name}`}</Option>
                                        :
                                        <Option disabled
                                            key={d.id} value={d.id}>{`${d.name}`}&nbsp;
                                            <Tag icon={<MinusCircleOutlined />}
                                                color="red">Deshabilitado</Tag></Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="task"
                            rules={[{ required: true, message: 'Ingrese la tarea principal' }]}>
                            <Input placeholder="Tarea"
                            />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={12} md={2}>
                        <Form.Item name="SAT">
                            <Checkbox checked={workOrderIsSAT}
                                      onChange={value => setWorkOrderIsSAT(value.target.checked)}>Derivado de SAT</Checkbox>
                        </Form.Item>
                    </Col> */}
                    <Col xs={6} md={2}>
                        <Form.Item name="workOrderNumber"
                            rules={[{ required: true, message: 'Ingrese la orden de trabajo' }]}>
                            <InputNumber
                                style={{ width: '100%' }}
                                placeholder="Ingrese la orden de trabajo"
                                min={0}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={6} md={2}>
                        <Form.Item name="year"
                            rules={[{ required: true, message: 'Ingrese el año de la orden de trabajo' }]}>
                            <DatePicker picker="year" style={{ width: '100%' }} placeholder="Año O/T" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="clients">
                            <Select
                                mode="multiple"
                                maxTagCount={1}
                                placeholder="Comitente/s"
                                filterOption={false}
                                onSearch={filterClients}
                                style={{ width: '100%' }}>
                                {clientsFiltered.map(d => (
                                    d.enabled ?
                                        <Option
                                            key={d.id} value={d.id}>{`${d.name}`}</Option>
                                        :
                                        <Option disabled
                                            key={d.id} value={d.id}>{`${d.name}`}&nbsp;
                                            <Tag icon={<MinusCircleOutlined />}
                                                color="red">Deshabilitado</Tag></Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="locality"
                            rules={[{ required: true, message: 'Por favor, ingrese la localidad' }]}>
                            <Input placeholder="Localidad"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={3} className='per'>
                        <Form.Item name="startDate" style={{ width: '100%' }}>
                            <DatePicker format={'DD/MM/YYYY'} placeholder="Inicio" style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={3} className='per'>
                        <Row style={{ width: '100%' }}>
                            <Col xs={9} style={{ width: '100%' }}>
                                <Form.Item name="expectedCompletionDate" >
                                    <DatePicker format={'DD/MM/YYYY'} placeholder="Finalización prevista"
                                        style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                            <Col xs={3}>
                                <GoogleCalendarIcon onClick={onAddExpectedCompletionDateToGoogleCalendar} />
                            </Col>
                        </Row>
                    </Col>
                    {/*<Col xs={6} md={3}>*/}
                    {/*    <Form.Item name="deliveryDate">*/}
                    {/*        <DatePicker format={'DD/MM/YYYY'} placeholder="Entrega" style={{ width: '100%' }}/>*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                </Row>
                <Row center='xs'>
                    <Col xs={12} md={3}>
                        <Form.Item name="effectiveEndDate">
                            <DatePicker format={'DD/MM/YYYY'} placeholder="Finalización"
                                style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={3} md={3}>
                        <Form.Item name="delivered" valuePropName="checked">
                            <Checkbox onChange={(e) => setIsDelivered(e.target.checked)}>Entregado</Checkbox>
                        </Form.Item>
                    </Col>
                    <Col xs={12} sm={3} md={3}>
                        <Row>
                            <Form.Item name="outsourced" valuePropName="checked">
                                <Checkbox onChange={handleCheckboxChange}>Tercerizado</Checkbox>
                            </Form.Item>
                        </Row>
                    </Col>
                    <Col xs={12} sm={3} md={3}>
                        <Form.Item
                            name="engineeringDays"
                            dependencies={['delivered']}
                            rules={[
                                ({ getFieldValue }) => ({
                                    validator(rule, value) {
                                        if (getFieldValue('delivered') && (value === undefined || value === "0" || value === 0 || value === "")) {
                                            return Promise.reject('Ingrese los días de ingeniería realizados');
                                        } else {
                                            return Promise.resolve();
                                        }
                                    }
                                })
                            ]}
                        >
                            <Input
                                type='number'
                                placeholder="Días de ingeniería realizados"
                                disabled={!isDelivered}
                            />
                        </Form.Item>
                    </Col>
                    {/* <Col xs={12} sm={3} md={3}>
                        <Form.Item name="payAtDay" valuePropName="checked">
                            <Checkbox>Pago al dia</Checkbox>
                        </Form.Item>
                    </Col> */}
                </Row>
                <Row>
                    {/* <Col xs={12} sm={6} md={3}>
                        <p className='prueba'>Topografía</p>
                        <Form.Item name="hasTopography" style={{ textAlign: 'start' }}>
                            <Select placeholder="Seleccione el estado de la topografía">
                                <Option value="No contempla">No contempla</Option>
                                <Option value="Pendiente de viaje">Pendiente de viaje</Option>
                                <Option value="Procesamiento en gabinete">Procesamiento en gabinete</Option>
                                <Option value="Terminada">Terminada</Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
                    {/* <Col xs={12} sm={6} md={2}>
                        <p className='prueba'>Porcentaje de avance</p>
                        <Form.Item name="completionPercentage">
                            <InputNumber
                                style={{ width: '100%' }}
                                placeholder="Avance"
                                min={0}
                                max={100}
                                formatter={value => `${value}%`}
                                parser={value => value.replace('%', '')}
                            />
                        </Form.Item>
                    </Col> */}
                    {/*<Col xs={12} sm={4} md={2}>*/}
                    {/*    <Form.Item name="onTime" valuePropName="checked">*/}
                    {/*        <Checkbox>A tiempo</Checkbox>*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="quotationObservations">
                            <TextArea placeholder="Observaciones de contratación" autoSize={{ minRows: 2, maxRows: 4 }} disabled={true} />
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="trackingLink">
                            <Input placeholder="Link de seguimiento" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row center='xs'>
                    <Col xs={12}>
                        {
                            isEditing ?
                                <Form.Item name="fileItem" style={{ textAlign: 'center' }}>
                                    <Row center='xs'>
                                        <Space>
                                            Orden de trabajo pdf:
                                            <div className='fileName' onClick={() => downloadFile('order')}> {fileName}</div>
                                            {
                                                fileName ?
                                                    <CloseOutlined onClick={() => deleteFile('order')} />
                                                    : null
                                            }
                                        </Space>
                                    </Row>
                                </Form.Item>
                                : null
                        }
                        {
                            fileName ?
                                <Form.Item name="fileItem" style={{ textAlign: 'center' }}>
                                    <Dragger {...draggerProps}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Clickea o arrastra un archivo para cargar</p>
                                    </Dragger>
                                </Form.Item>
                                :
                                <Form.Item name="fileItem" style={{ textAlign: 'center' }} rules={[{ required: true, message: 'Debe ingresar un pdf asociado' }]}>
                                    <Dragger {...draggerProps}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Clickea o arrastra un archivo para cargar</p>
                                    </Dragger>
                                </Form.Item>
                        }
                    </Col>
                    <a ref={linkFileRef} href="" target='_blank' download />
                </Row>
                <Row center='xs'>
                    <Col xs={12}>
                        {
                            isEditing ?
                                <Form.Item name="fileItemValidation" style={{ textAlign: 'center' }}>
                                    <Row center='xs'>
                                        <Space>
                                            Validación del proyecto pdf:
                                            <div className='fileName' onClick={() => downloadFile('validation')}> {fileNameValidation}</div>
                                            {
                                                fileNameValidation ?
                                                    <CloseOutlined onClick={() => deleteFile('validation')} />
                                                    : null
                                            }
                                        </Space>
                                    </Row>
                                </Form.Item>
                                : null
                        }
                        {
                            fileNameValidation ?
                                <Form.Item name="fileItemValidation" style={{ textAlign: 'center' }}>
                                    <Dragger {...draggerPropsValidation}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Clickea o arrastra un archivo para cargar</p>
                                    </Dragger>
                                </Form.Item>
                                :
                                <Form.Item name="fileItemValidation" style={{ textAlign: 'center' }}>
                                    <Dragger {...draggerPropsValidation}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Clickea o arrastra un archivo para cargar</p>
                                    </Dragger>
                                </Form.Item>
                        }
                    </Col>
                    <a ref={linkValidationFileRef} href="" target='_blank' download />
                </Row>
                {/* Tabla de items con porcentajes libre y facturado */}
                {isEditing && workOrderToEdit && (workOrderToEdit.selectedItems || workOrderToEdit.items) && (workOrderToEdit.selectedItems || workOrderToEdit.items).length > 0 && (
                    <Row center="xs" style={{ marginTop: '20px', marginBottom: '20px' }}>
                        <Col xs={12}>
                            <h3 style={{ textAlign: 'center', marginBottom: '16px' }}>Items aprobados</h3>
                            <Table
                                dataSource={workOrderToEdit.selectedItems || workOrderToEdit.items}
                                rowKey="id"
                                pagination={false}
                                size="small"
                                bordered
                                columns={[
                                    {
                                        title: 'Id',
                                        dataIndex: 'id',
                                        key: 'id',
                                        width: 80,
                                        align: 'center',
                                    },
                                    {
                                        title: 'Nombre',
                                        dataIndex: 'name',
                                        key: 'name',
                                        width: 200,
                                        ellipsis: true,
                                    },
                                    {
                                        title: 'Descripción',
                                        dataIndex: 'description',
                                        key: 'description',
                                        ellipsis: {
                                            showTitle: false,
                                        },
                                        render: (text) => (
                                            <span title={text} style={{ wordBreak: 'break-word' }}>
                                                {text}
                                            </span>
                                        ),
                                    },
                                    {
                                        title: 'Precio (ARS)',
                                        dataIndex: 'price',
                                        key: 'price',
                                        width: 120,
                                        render: (price) => `$ ${price?.toFixed(2) || '0.00'}`,
                                        align: 'right'
                                    },
                                    {
                                        title: 'Precio (USD)',
                                        dataIndex: 'priceUsd',
                                        key: 'priceUsd',
                                        width: 120,
                                        render: (priceUsd) => priceUsd ? `US$ ${priceUsd.toFixed(2)}` : '-',
                                        align: 'right'
                                    },
                                    {
                                        title: '% Libre para facturar',
                                        key: 'invoicedFreePercentaje',
                                        width: 180,
                                        align: 'center',
                                        render: (_, record) => (
                                            <Form.Item
                                                name={`invoicedFreePercentajeItem${record.id}`}
                                                rules={[{ required: true, message: 'Requerido' }]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    placeholder="%"
                                                    min={0}
                                                    max={100}
                                                    formatter={value => `${value}%`}
                                                    parser={value => value.replace('%', '')}
                                                />
                                            </Form.Item>
                                        )
                                    },
                                    {
                                        title: '% Facturado',
                                        key: 'invoicedPercentaje',
                                        width: 180,
                                        align: 'center',
                                        render: (_, record) => (
                                            <Form.Item
                                                name={`invoicedPercentajeItem${record.id}`}
                                                rules={[{ required: true, message: 'Requerido' }]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber
                                                    style={{ width: '100%' }}
                                                    placeholder="%"
                                                    min={0}
                                                    max={100}
                                                    formatter={value => `${value}%`}
                                                    parser={value => value.replace('%', '')}
                                                />
                                            </Form.Item>
                                        )
                                    },
                                    {
                                        title: 'Terminado',
                                        key: 'completed',
                                        width: 120,
                                        align: 'center',
                                        render: (_, record) => (
                                            <Form.Item
                                                name={`completedItem${record.id}`}
                                                valuePropName="checked"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Checkbox />
                                            </Form.Item>
                                        )
                                    }
                                ]}
                            />
                        </Col>
                    </Row>
                )}
                <Row center="xs">
                    <Col xs={4}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                {isEditing ? 'Actualizar' : 'Cargar'}
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col xs={4}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button onClick={clearWorkOrder} loading={loading}>
                                {isEditing ? 'Restablecer' : 'Limpiar'}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Grid>
        </Spin>
    )
})

FormWorkOrder.propTypes = {
    loading: PropTypes.bool.isRequired,
    employees: PropTypes.object,
    clients: PropTypes.object,
    onSubmitWorkOrder: PropTypes.func.isRequired,
    isEditing: PropTypes.bool,
    workOrderToEdit: PropTypes.object,
    bidData: PropTypes.object
}

export default FormWorkOrder
